<h1 mat-dialog-title>Bank Transfer Info of <strong>Amount: </strong> {{ data.amount }} for <strong>Property Id: </strong> {{ data.property_id }}</h1>
<div mat-dialog-content>
    <div class="row m-2">
        <form class="col-sm-12 row" [formGroup]="basicInfoForm">
            <div class="col-sm-12 col-md-6 form-group">
                <label for="payment">
                    Payment Method
                </label>
                <input class="form-control" formControlName="paymentMethod" id="payment">
            </div>
            <div class="col-sm-12 col-md-6 form-group">
                <label for="transaction">
                    Reference Code
                </label>
                <input class="form-control" formControlName="transaction_id" id="transaction">
            </div>
            <div class="col-sm-12 image-holder">
                <img *ngIf="!imgURL" src="assets/placeholder-image.png" />
                <img *ngIf="imgURL" [src]="imgURL" />
                <div class="file-chooser">
                  <p class="text-center">Select Voucher Image / Proof of Payment</p>
                  <input (change)="fileChangeEvent($event)" type="file">
                </div>
            </div>
        </form>
    </div>
</div>
<div mat-dialog-actions class="row col-sm-12 justify-content-end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button (click)="saveBankDepositInfo()" cdkFocusInitial>Save</button>
</div>